<template>
  <h1 class="title mb-2" style="text-align: left; font-size: calc(1rem + 2vw); color: white;  font-weight: bold " >Рецепт "Апельсиновые перепёлки горячего копчения в гриле"</h1>
  <div class="" >
    <img
        src="/assets/recipe2.svg"
        class="recipe-image"
        alt="..."
    >
  </div>
  <div class="recipe-1-container text-white text-start mt-3" style="">
    <div class="layout__content">
      <div class="ms-1 w-big-screen " style="font-size: calc(1rem + 0.4vw);">
        <p>1. Замариновать тушки в рассоле в холодильнике 1 сутки. На 1 кг перепёлок нам потребуется: 1 литр воды, 65 г соли, молотая апельсиновая цедра и черный перец по вкусу;</p>
        <p>2. Промыть перепёлок под холодной водой;</p>
        <p>3. Надеть перепёлок на ростер;</p>
        <p>4. Просушить 60-90 минут на ветру, под вентилятором или, слегка, феном;</p>
        <p>5. Коптить на непрямом жаре в гриле при 110-130°C около часа до 74°C внутри грудки. Если уверены в продукте, то попробуйте довести до 65°C - получаются очень нежные, только в этом случае обязательно хорошо вычищайте из тушки остатки лёгких и другие внутренности. Для копчения используйте пару горстей замоченной щепы (яблоня, груша, ольха).</p>
      </div>
      <p style="font-size: calc(1rem + 0.4vw);"><strong>Приятного аппетита!</strong></p>
    </div>
  </div>

</template>

<style scoped lang="scss">

@media (max-width: 600px) {
  .recipe-image {
    width: 100%!important;
    height: auto;
    min-height: 30%;
    display: block; /* Занимает всю ширину родительского элемента */
  }

}
@media (max-width: 1100px) and (min-width: 601px) {
  .recipe-image {
    width: 100%!important;
    height: auto;
    min-height: 30%;
    display: block; /* Занимает всю ширину родительского элемента */
  }

}
@media (min-width: 1101px) and (max-width: 1799px) {
  .w-big-screen{
    width: 50%!important;
  }
  .recipe-image {
    width: 60%!important;
    height: auto;
    min-height: 30%;
    display: block; /* Занимает всю ширину родительского элемента */
  }

}
@media (min-width: 1800px) {
  .w-big-screen{
    width: 50%!important;
  }
  .recipe-image {
    width: 50%;
    height: auto;
    min-height: 30%;
    display: block; /* Занимает всю ширину родительского элемента */
  }

}

.recipes-container{
  position: relative;
  max-width: 100%;
  margin-bottom: 5%;
  min-width: 15%;
  width: auto;
}
</style>
